import DatabaseModel from './DatabaseModel.js';
import { unwrapDto } from './responseUtils.js';

// Apartado Novedades: el historial de versiones publicadas (#250).
//
// Solo LEE. La publicación no se hace desde el navegador y no puede hacerse: vive en otra ruta de la
// API (`/movilidad/internal/novedades/...`), con identidad de servicio y su propia cadena de
// seguridad, y aquí no hay ni ruta ni secreto con los que llamarla. Eso es a propósito: un token de
// publicación en el front sería un token en el navegador de toda la plantilla.
//
// Tampoco se consulta GitHub desde el navegador: lo que se enseña sale de la base de la propia
// aplicación, por esta API.
const Novedades = Object.create(DatabaseModel);

Novedades.model = 'novedades';
Novedades.modelFront = 'novedades';

/**
 * GET /movilidad/novedades?pagina=N&tamano=M
 *   → { pagina, tamano, total, hayMas, revisionHistorial,
 *       versiones: [{ version, fechaDespliegue, mejoras, correcciones,
 *       mejorasConTareas, correccionesConTareas, vigente, retirada, motivoRetirada }] }
 *
 * `mejoras` y `correcciones` son listas de CADENAS: el texto de cada nota, igual que siempre.
 *
 * `mejorasConTareas` y `correccionesConTareas` (#556) traen las MISMAS notas, en el mismo orden, como
 * `{ texto, tareas: [58] }`: `tareas` son los números de las incidencias del orquestador que
 * originaron ESA nota —no de la versión entera— y la pantalla los pinta como `#58` junto al texto.
 * Viene vacía cuando no consta, que es el caso de todo el historial publicado antes de #556. No se
 * consulta GitHub para pintarlos: son el número y nada más.
 *
 * Son dos formas de la misma lista, así que se pinta UNA: la pantalla prefiere los campos con tareas
 * si vienen —también vacíos— y usa los anteriores si no (ver `notasDe()` en `novedades.vue`). Eso es
 * lo que la deja funcionando contra una API que todavía no haya salido, y lo que deja funcionando a
 * una pestaña abierta desde antes del despliegue contra la API nueva.
 *
 * `revisionHistorial` dice con qué estado del historial se montó la página. Es OPACA: no se
 * interpreta, sólo se compara entre dos páginas para saber si son de la misma lista. Hace falta
 * además de `total` porque una retirada conserva el registro y el total no se mueve.
 *
 * `fechaDespliegue` viene en ISO-8601 UTC con la `Z` puesta; la pantalla la presenta en Europe/Madrid.
 *
 * Lo que NO viene, y no se echa en falta: el identificador del despliegue, las revisiones de los
 * componentes y quién publicó. Son metadatos técnicos y la API no los devuelve en este listado.
 *
 * `hayMas` lo decide el servidor. No se calcula aquí con la aritmética de página y tamaño: ahí es
 * donde se cuela un «Ver más» que no trae nada.
 */
Novedades.pagina = function (pagina, tamano) {
    const self = this;
    const params = 'pagina=' + encodeURIComponent(pagina || 0)
        + '&tamano=' + encodeURIComponent(tamano);
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '?' + params,
        method: 'GET'
    }, false).then(unwrapDto);
};

export default Novedades;
